
import { defineComponent, PropType } from 'vue';
import { DocFull } from '../../docsHelp';

export default defineComponent({
  name: 'DocContent',
  props: {
    doc: { type: Object as PropType<DocFull>, required: true },
    anchor: { type: String, default: null },
    offline: { type: Boolean, default: false },
    updatedNote: { type: String, default: null },
  },
  // Emitted before following a link to another guide (the help sheet closes on route change).
  emits: ['navigate'],
  data() {
    return { showChangelog: false };
  },
  mounted() {
    this.scrollToAnchor(this.anchor);
  },
  watch: {
    anchor(value: string | null) {
      this.scrollToAnchor(value);
    },
  },
  methods: {
    scrollToAnchor(id: string | null) {
      if (!id) {
        return;
      }
      this.$nextTick(() => {
        const el = (this.$refs.root as HTMLElement).querySelector('#' + CSS.escape(id));
        if (el) {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    },
    // In-guide #section links scroll within the guide; other links open outside the app.
    onClick(event: MouseEvent) {
      const link = (event.target as HTMLElement).closest('a');
      if (!link) {
        return;
      }
      const href = link.getAttribute('href') || '';
      if (href.startsWith('#')) {
        event.preventDefault();
        this.showChangelog = false;
        this.scrollToAnchor(href.substring(1));
      } else if (href.startsWith('/help/')) {
        // Link to another guide: open it in the app's guide screen.
        event.preventDefault();
        this.$emit('navigate');
        this.$router.push(href);
      } else if (/^https?:/i.test(href)) {
        event.preventDefault();
        window.open(href, '_system');
      }
    },
  },
});
